import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "semantic-ui-react";
import { displayNetworkCodeOption, IParameter } from "../../models/parameter";
import { ParameterModal } from "../../components/ParameterManagementTable/ParameterModal";
import { dateFormat, localeString } from "../../helpers/commonHelper";

interface IProps {
    parameter: IParameter;
    isDevelopment?: boolean;
    refreshTrigger?: () => void;
}

export const NclpParameterCard = ({ parameter, isDevelopment, refreshTrigger }: IProps) => {
    const [deadline, setDeadline] = useState<string>("");
    const [editParameterModalOpen, setEditParameterModalOpen] = useState(false);

    useEffect(() => {
        setDeadline(parameter.deadline);
    }, [parameter]);

    return (
        <>
            <Card
                key={parameter.guid}
                as={!isDevelopment && Link}
                to={
                    !isDevelopment &&
                    `/parameters/view/${parameter.guid}/answer/${parameter.answerGuid}`
                }
                onClick={() => isDevelopment && setEditParameterModalOpen(true)}
            >
                <Card.Content>
                    <Card.Header>{parameter.name}</Card.Header>
                    <Card.Meta>{parameter.description}</Card.Meta>
                    <Card.Description>
                        <strong>Network code: </strong>
                        {displayNetworkCodeOption(parameter.networkCode)}
                    </Card.Description>
                    {!deadline.startsWith("0001-01-01") && (
                        <Card.Description>
                            <strong>Deadline: </strong>
                            {deadline
                                ? new Date(deadline).toLocaleString(localeString, dateFormat)
                                : "N/A"}
                        </Card.Description>
                    )}
                </Card.Content>
            </Card>
            {editParameterModalOpen && (
                <ParameterModal
                    parameterGuid={parameter.guid}
                    modalOpen={editParameterModalOpen}
                    closeModal={() => setEditParameterModalOpen(false)}
                    refreshTrigger={refreshTrigger}
                    isDevelopment={true}
                ></ParameterModal>
            )}
        </>
    );
};
